import { get } from '../../utils/objectHelpers';
import StrTabList from '../str-tablist/component';

export default class {
    get tabs() {
        const tabs = get(this.input, 'page.modules.TABS_MODULE.tabs', []);
        // Add panelId to each tab
        tabs.forEach(tab => {
            StrTabList.addTabProperties(tab);
        });
        return tabs;
    }
    get shopHeader() {
        return {
            searchModule: get(this.input, 'page.modules.SEARCH_THE_STORE_MODULE'),
            categoryModule: get(this.input, 'page.modules.STORE_CATEGORIES_MODULE'),
            shipLocationModule: get(this.input, 'page.modules.SHIPPING_DESTINATION_MODULE')
        };
    }
    get spinner() {
        return get(this.input, 'page.modules.LOADING_SPINNER_MODULE');
    }
    onCreate(input) {
        this.input = input;
        this.state = {
            selectedTabIndex: 0
        };
    }
    onInput(input) {
        this.input = input;
    }
    onMount() {
        document.addEventListener('str-tab-change-event', (evt) => {
            const panelId = evt.detail.panelId;
            if (typeof panelId !== 'undefined') {
                this.state.selectedTabIndex = this.tabs.findIndex(tab => tab.panelId === panelId);
            }
        });
    }
}
